module.exports = __webpack_public_path__ + "img/bi-bg-placeholder.26abff3d.png";